function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var HouseholdApiService = /*#__PURE__*/function () {
  function HouseholdApiService() {
    _classCallCheck(this, HouseholdApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(HouseholdApiService, [{
    key: "GetHousehold",
    value: function GetHousehold() {
      var url = "".concat(this._appRoot, "/Api/HouseholdApi/GetHousehold");
      return Ajax.Post(url);
    }
  }, {
    key: "GetHouseholdMembers",
    value: function GetHouseholdMembers() {
      var url = "".concat(this._appRoot, "/Api/HouseholdApi/GetHouseholdMembers");
      return Ajax.Post(url);
    }
  }, {
    key: "UpdateHousehold",
    value: function UpdateHousehold(formData) {
      var url = "".concat(this._appRoot, "/Api/HouseholdApi/UpdateHousehold");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "UpdateHouseholdMember",
    value: function UpdateHouseholdMember(formData) {
      var url = "".concat(this._appRoot, "/Api/HouseholdApi/UpdateHouseholdMember");
      return Ajax.Post(url, formData);
    }
  }]);

  return HouseholdApiService;
}();